import React, { useState, useEffect, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateBuilderLinks } from "../../../../redux/slices/linksBuilder";
import { base64ToFile, handleFilesUpdate } from "../../../../hooks/helpers";
import { setIsStorageModal } from "../../../../redux/slices/modals";
import FileUpload from "../../../../components/input/fileUpload";
import usePremium from "../../../../hooks/usePremium";
import { registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import { useDebouncedCallback } from "use-debounce";
import useUserInfo from "../../../../hooks/useUserInfo";

export default memo(function AddImgToLink({ linkItem }) {
  const { lang, data, savedLinks } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.linkList || [],
    data: state.linksBuilder.data,
    savedLinks: state.saveValue.valueLinkList.links,
  }));

  const [file, setFile] = useState([]);
  const dispatch = useDispatch();
  const { isPremium } = usePremium();
  const debouncedHandleFilesUpdate = useDebouncedCallback(
    handleFilesUpdate,
    500
  );
  const { isAdmin } = useUserInfo();

  const maxFileSize = isAdmin ? null : isPremium ? 99 : 10;
  registerPlugin(FilePondPluginFileValidateType);

  useEffect(() => {
    if (
      savedLinks.length &&
      savedLinks.find((link) => link.id === linkItem.id)?.img
    ) {
      const base64Img = savedLinks.find((link) => link.id === linkItem.id).img;
      setFile([base64ToFile(base64Img, "linkImg")]);
    }
  }, [savedLinks]);

  useEffect(() => {
    const reader = new FileReader();
    if (file[0]?.file) {
      reader.readAsDataURL(file[0].file);
      reader.onload = () => {
        const updateData = data.links.map((item) =>
          item.id === linkItem.id ? { ...item, img: reader.result } : item
        );
        dispatch(updateBuilderLinks(updateData));
      };
    }
  }, [file]);

  return (
    <>
      <FileUpload
        className="mb-1"
        files={file}
        onupdatefiles={(files) =>
          debouncedHandleFilesUpdate(
            files,
            setFile,
            () => dispatch(setIsStorageModal(true)),
            !isAdmin
          )
        }
        onremovefile={() => {
          setFile([]);
          const updateData = data.links.map((item) =>
            item.id === linkItem.id ? { ...item, img: "" } : item
          );
          dispatch(updateBuilderLinks(updateData));
        }}
        allowFileTypeValidation={true}
        maxFileSize={maxFileSize ? `${maxFileSize}MB` : null}
        allowMultiple={false}
        maxFiles={1}
        name="gallery"
        dataAllowReorder={true}
        allowReorder={true}
        acceptedFileTypes={["image/jpeg", "image/png"]}
        label={lang[5]}
        popoverText={null}
        showReplaceBtn
      />
      <div className="fs-7 text-gray mb-3 text-capitalize">{lang[29]}</div>
    </>
  );
});
